import { render, staticRenderFns } from "./CheckBoxV2.vue?vue&type=template&id=f65c8420&scoped=true&"
import script from "./CheckBoxV2.vue?vue&type=script&lang=js&"
export * from "./CheckBoxV2.vue?vue&type=script&lang=js&"
import style0 from "./CheckBoxV2.vue?vue&type=style&index=0&id=f65c8420&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65c8420",
  null
  
)

export default component.exports